/**
 * PSP-specific reason matchers.
 *
 * Each adapter owns the strings THAT PSP invented. The domain classifier
 * folds them into PaymentFailureCode. A new provider adds a file here; it
 * does not touch checkout.
 */
import type { PaymentFailureCode } from '../codes'

export type FailureMatcher = {
  test: (text: string) => boolean
  code: PaymentFailureCode
}

export const infrastructureFailureMatchers: readonly FailureMatcher[] = [
  {
    test: (text) => /function failed to start|worker failed to boot|BOOT_ERROR/i.test(text),
    code: 'CREATE_FAILED',
  },
  {
    test: (text) =>
      /start time cannot be in the past|rental start time cannot be in the past/i.test(text),
    code: 'START_IN_PAST',
  },
]

/** Wompi SV TEST/live reason bodies we have actually seen. */
export const wompiFailureMatchers: readonly FailureMatcher[] = [
  {
    test: (text) => /error generi[co].*validaci[oó]n/i.test(text),
    code: 'VALIDATION',
  },
  {
    test: (text) => /aplicativo.*productivo/i.test(text),
    code: 'APP_NOT_LIVE',
  },
  {
    test: (text) => /inconveniente en la transacci[oó]n/i.test(text),
    code: 'VALIDATION',
  },
  {
    test: (text) => /cvv no es v[aá]lido|tarjeta vencida|vencimiento inv[aá]lido/i.test(text),
    code: 'VALIDATION',
  },
  {
    test: (text) =>
      /fondos insuficientes|insufficient funds|tarjeta rechazada|denegad|transacci[oó]n denegada|cvv ['"]?111['"]?/i.test(
        text,
      ),
    code: 'DECLINED',
  },
]

export const paypalFailureMatchers: readonly FailureMatcher[] = [
  {
    test: (text) => /order.*could not be created|paypal.*disabled/i.test(text),
    code: 'HOSTED_CHECKOUT_FAILED',
  },
]

export const PROVIDER_FAILURE_MATCHERS: readonly FailureMatcher[] = [
  ...infrastructureFailureMatchers,
  ...wompiFailureMatchers,
  ...paypalFailureMatchers,
]
